export const decisionTreeResultLinkType = 'decisionTreeResult';
